import { render, staticRenderFns } from "./newHiYouCai.vue?vue&type=template&id=42b97714&scoped=true"
import script from "./newHiYouCai.vue?vue&type=script&lang=js"
export * from "./newHiYouCai.vue?vue&type=script&lang=js"
import style0 from "./newHiYouCai.vue?vue&type=style&index=0&id=42b97714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b97714",
  null
  
)

export default component.exports